/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuHoursGroupAssociationsResponse } from '../../models/menu-hours-group-associations-response';

export interface MenuHoursGroupAssociationsGet$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
  hoursId: string;
}

export function menuHoursGroupAssociationsGet(http: HttpClient, rootUrl: string, params: MenuHoursGroupAssociationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuHoursGroupAssociationsResponse>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupAssociationsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.path('hoursId', params.hoursId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuHoursGroupAssociationsResponse>;
    })
  );
}

menuHoursGroupAssociationsGet.PATH = '/menus/{menuId}/hours/{hoursId}/associations';
